import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
axios.defaults.withCredentials = true;




function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
  try {
    const res = await axios.post("/api/adminLogin.php",
      {
        email,
        password,
      },
      { withCredentials: true }
    );

    console.log(res.data);

    if (res.data.success) {
      localStorage.setItem("admin", JSON.stringify(res.data.admin));

      // ✅ IMPORTANT → go to App.js (form)
      navigate("/form");
    } else {
      alert("Login failed");
    }
  } catch (err) {
    console.error(err);
    alert("Error");
  }
};

 return (
  <div className="login-page">

    {/* 🔙 BACK BUTTON */}
    <button
      className="back-btn"
      onClick={() => navigate("/")}
    >
      ← Retour
    </button>

    <div className="login-card">

      <h2 className="login-title">Connexion admin</h2>
      <p className="login-subtitle">Accès sécurisé au dashboard</p>

      {/* EMAIL */}
      <div className="input-group">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder=" "
          required
        />
        <label>Email</label>
      </div>

      {/* PASSWORD */}
      <div className="input-group">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder=" "
          required
        />
        <label>Mot de passe</label>
      </div>

      {/* LOGIN */}
      <button onClick={handleLogin} className="login-btn">
        Se connecter
      </button>

    </div>

  </div>
);
}

export default AdminLogin;